import { render, staticRenderFns } from "./StallionCampagneNotClosed.vue?vue&type=template&id=358311c2&"
import script from "./StallionCampagneNotClosed.vue?vue&type=script&lang=js&"
export * from "./StallionCampagneNotClosed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports